export default "__VITE_ASSET__zvpbpJH3__";